import { select } from 'd3-selection';
import { geoPath } from 'd3-geo';
import { saveElementsStore } from '../../actions/index';
import { callZoomMap } from './events';
import {
  handleMouseOver,
  handleMouseOut,
  handleMouseMove,
} from './mouse';
import store from '../../store';
import handlerCurrentKey from './draw';

const { getState, dispatch } = store;
const main = document.querySelector('main');
const app = select('.mapa');
const props = {
  width: main.clientWidth,
  height: (main.clientWidth * 0.8),
};

function newFill(item) {
  const { initial } = getState();
  const { param } = initial;
  const { currentKey, currentScale } = param;
  if (item.dadosMunicipio) {
    const value = handlerCurrentKey(item.dadosMunicipio[currentKey.key], currentKey);
    if (value) {
      return currentScale(value);
    }
  }
  return false;
}

// RENDER MAP
export default () => {
  const { initial } = getState();
  const {
    dataGeo,
    listMerge,
    scales,
    param,
  } = initial;

  const { estados } = dataGeo;
  const { width, height } = props;
  const { currentKey } = param;
  const { type } = currentKey;

  const path = geoPath();

  app.append('div')
    .attr('class', 'mapa__tooltip');

  const svg = app.append('svg')
    .attr('class', 'mapa__svg')
    .attr('viewBox', `0 0 ${width} ${height}`)
    .attr('preserveAspectRatio', 'xMaxYMin');

  const container = svg
    .append('g')
    .attr('class', 'mapa__container');

  // DESENHA CADA MUNICIPIO
  const m = container
    .append('g')
    .attr('class', 'mapa__municipios');

  m.selectAll('.path__municipio')
    .data(listMerge)
    .enter()
    .append('path')
    .attr('d', path)
    .attr('class', 'path__municipio')
    .attr('data-id', d => d.id)
    .style('fill', (d) => {
      const val = newFill(d);
      if (val) {
        return val;
      }
      return 'transparent';
    })
    .style('fill-opacity', ({ dadosMunicipio }) => {
      if (dadosMunicipio && !type) {
        const { candidatos } = dadosMunicipio;
        if (candidatos.constructor === Array && candidatos.length !== 0) {
          const { total_percentual } = candidatos[0]; // eslint-disable-line
          const retorno = scales.percentual()(parseFloat(total_percentual));
          return retorno;
        }
      }
      return '';
    })
    .style('stroke-width', 0.03)
    .style('stroke', 'white')
    .on('mouseover', handleMouseOver)
    .on('mousemove', handleMouseMove)
    .on('mouseout', handleMouseOut);


  // DESENHA CADA ESTADO
  const e = container
    .append('g')
    .attr('class', 'mapa__estados');

  e.selectAll('.path__estado')
    .data([estados])
    .enter()
    .append('path')
    .attr('d', path)
    .attr('class', 'path__estado')
    .attr('data-uf', ({ properties }) => properties.uf)
    .style('fill', 'red')
    .on('click', callZoomMap);

  dispatch(saveElementsStore({
    container,
    path,
    props,
  }));

  // CLICK PATH TRIGGER
  const selectedPath = document.querySelector('.path__estado');
  const eventClick = new Event('click');
  selectedPath.dispatchEvent(eventClick);
};




// WEBPACK FOOTER //
// ./src/components/mapa/render.js